import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "navigation", "menuButton", "dialog", "searchInput"]

  connect() { this.element.classList.add("signal-enhanced") }

  disconnect() { this.beforeCache() }

  toggleMenu() {
    const open = !this.headerTarget.classList.contains("menu-open")
    this.headerTarget.classList.toggle("menu-open", open)
    this.menuButtonTarget.setAttribute("aria-expanded", String(open))
  }

  shortcut(event) {
    if (this.hasDialogTarget && (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
      event.preventDefault()
      this.dialogTarget.open ? this.closeSearch() : this.openSearch()
    }
    if (event.key === "Escape" && this.headerTarget.classList.contains("menu-open")) this.toggleMenu()
  }

  openSearch(event) {
    if (!this.hasDialogTarget || typeof this.dialogTarget.showModal !== "function") return
    event?.preventDefault()
    this.previousFocus = document.activeElement
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
    this.searchInputTarget.focus()
  }

  closeSearch() { if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close() }

  searchClosed() { if (this.previousFocus?.isConnected) this.previousFocus.focus() }

  backdrop(event) {
    if (event.target !== this.dialogTarget) return
    const rect = this.dialogTarget.getBoundingClientRect()
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeSearch()
  }

  beforeCache() {
    this.closeSearch()
    if (this.hasHeaderTarget) this.headerTarget.classList.remove("menu-open")
    if (this.hasMenuButtonTarget) this.menuButtonTarget.setAttribute("aria-expanded", "false")
  }
}
